/**
 * Returns a shallow copy of the given object, with all properties
 * whose values are blank strings removed.
 *
 * @param obj A generic object of keys and values
 * @param filterFunc A filter function that is passed entries from the first
 * argument
 */
type FilterFunction = Parameters<typeof Array.prototype.filter>[0];
export default (obj: GenericObject | unknown, filterFunc: FilterFunction) =>
  Object.entries(obj as GenericObject)
    .filter(filterFunc)
    .reduce((acc: GenericObject, [key, value]) => ({ ...acc, [key]: value }), {});
